export default __webpack_public_path__ + "static/media/icn-wtd-max-speed.839c897b.svg";